"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mainHostnameFromHostname(hostname) {
    return ((hostname || '').replace(/-dot-/g, '.').replace(/\.s-plat/, '').match(/([^.]+\.(lh|no))/) || [])[1] || 'aftenposten.no';
}
exports.default = mainHostnameFromHostname;
//# sourceMappingURL=mainHostnameFromHostname.js.map